<template>
  <b-modal
    id="modal-multi-3"
    size=""
    title="Nuevo Historial"
    ok-only
    ok-title="Accept"
    v-model="$store.state.someVariables.showNuevoHistorial"
  >
    <b-card-text class="my-1">
      Ingrese una observación para el historial, esta observación le debe
      permitir reconocer el motivo de la creación del historial
      <br />
      <b>
        Ejemplo Historial de horarios de Maxima primera y segunda para cancha 1
        y cancha 2</b
      >
      <br />
      Recuerde que una vez creado el historial, esta no se podrá modificar
    </b-card-text>
    <div class="form-label-group">
      <b-form-textarea
        id="textarea-auto-height"
        placeholder="Observación breve"
        rows="2"
        size="sm"
        max-rows="3"
        v-model="nombreSlotsUs"
      />
      <label for="floating-auto-height">Observación breve *</label>
    </div>
    <template #modal-footer>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="outline-primary"
        class="float-right mr-1 "
        @click="close"
      >
        Cancelar
      </b-button>
      <b-button
        v-if="!showLoading"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="float-right"
        @click="saveSlots"
      >
        Guardar
      </b-button>
      <div v-if="showLoading" class="text-center mt-1">
        <b-spinner variant="primary" label="Text Centered" />
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal,
  BCardText,
  BButton,
  BSpinner,
  BFormTextarea,
  // xxx,
  // xxxx,
  // sss,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import { computed } from '@vue/composition-api'
// import { ref } from '@vue/composition-api'
// import apiCall from '../../utils/apiCall'
// import {
//   URL,
//   //   USER,
//   //   ROLES,
//   //   ESTADO_JUGADOR,
//   //   INSERT_DATA_PLAYER,
//   //   INSERT_DATA_HISTORY_PLAYER,
//   //   UPDATE_DATA_PLAYER,
// } from '../../utils/variables'

export default {
  components: {
    BModal,
    BCardText,
    BButton,
    BSpinner,
    BFormTextarea,
  },
  directives: {
    // 'b-popover': VBPopover,
    // heightFade,
    Ripple,
  },
  props: {
    dataFinalizarEtapa: Object,
    showLoading: Boolean,
    nombreSlots: String,
  },
  setup(props, { emit }) {
    const nombreSlotsUs = computed({
      get: () => props.nombreSlots,
      set: value => {
        // props.isManualProp = value
        emit('changeName', value)
      },
    })
    function close() {
      store.commit('someVariables/UPDATE_SHOW_SLOTS', false)
    }
    function saveSlots() {
      if (
        props.nombreSlots === '' ||
        props.nombreSlots === undefined ||
        props.nombreSlots === null
      ) {
        emit('error', 'Error, existen campos vacios')
      } else {
        emit('saveNuevoHistoria', { name: props.nombreSlots })
      }
    }

    return {
      close,
      saveSlots,
      // nombreSlots,
      nombreSlotsUs,
    }
  },
}
</script>
